export default "/assets/images/dust-video-thumbnail.99218486843ee84a.jpg";